import React, { useState } from 'react';
import { Modal, Form, Input, message, notification } from 'antd';
import { FeedbackType } from '@shared/constants/feedback';
import './styles.less'
const { TextArea } = Input;

export interface FeedbackProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: {
    feedbackType: FeedbackType;
    description: string;
    screenshots?: string[];
  }) => Promise<void>;
}

const FeedbackModal: React.FC<FeedbackProps> = ({ visible, onClose, onSubmit }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const prefixCls = 'feedback-modal'

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await onSubmit({
        feedbackType: FeedbackType.CREATOR,
        description: values.description,
      });
      notification.success({
        message: '创作激励提交成功',
        description: '创作激励申请已提交，我们会尽快处理！',
        placement: 'topRight',
        duration: 4,
        style: { backgroundColor: '#f6ffed' }
      });
      form.resetFields();
      onClose();
    } catch (err) {
      message.error('提交失败，请重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={'创作激励'}
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={submitting}
      width={520}
      okText={'提交表格'}
      cancelText="取消"
    >
      <div className={`${prefixCls}-promotion`}> 
        <div className={`${prefixCls}-promotion-content`}>
          <div className={`${prefixCls}-promotion-item`}>
            <span className={`${prefixCls}-promotion-index`}>1</span>
            <span className={`${prefixCls}-promotion-text`}>
              在小红书/抖音发布1条种草：20字以上+3张图，@橙子8设计，带 #橙子8设计 #电商设计 等话题
            </span>
          </div>
          <div className={`${prefixCls}-promotion-item`}>
            <span className={`${prefixCls}-promotion-index`}>2</span>
            <span className={`${prefixCls}-promotion-text`}>
              提交链接，1–2个工作日到账
              <span className={`${prefixCls}-highlight`}>3天会员</span>
              ；优秀作品加赠
              <span className={`${prefixCls}-highlight`}>7天会员</span>
              （以审核为准）
            </span>
          </div>
          <div className={`${prefixCls}-promotion-note`}>
            每人每号每周最多3次；发布后不得删除
          </div>
        </div>
      </div>
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="description"
          label={'创作链接'}
          rules={[
            { required: true, message: '请填写创作链接' },
            { pattern: /^(https?:\/\/)[^\s]+$/, message: '请输入有效链接' }
          ]}
        >
          <TextArea
            rows={3}
            placeholder={'请填写小红书/抖音笔记链接'}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FeedbackModal;
